import { format } from 'date-fns'

export const formatDateWithOrdinal = (date, formatType) => {
  const day = Number(format(date, 'd')) // Convert to number
  const monthYear =
    formatType == 'month' ? format(date, 'MMM') : format(date, 'MMMM, yyyy')

  const getOrdinalSuffix = day => {
    if (day > 3 && day < 21) return 'th'
    switch (day % 10) {
      case 1:
        return 'st'
      case 2:
        return 'nd'
      case 3:
        return 'rd'
      default:
        return 'th'
    }
  }

  const dayWithSuffix = day + getOrdinalSuffix(day)
  return `${dayWithSuffix} ${monthYear}`
}

export default function Debounce(fn, delay) {
  let timer
  return function () {
    let context = this,
      args = arguments
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(context, args)
    }, delay)
  }
}
